import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { AppState } from '../common/utils/AppState';
import { UtilCommon } from '../common/utils/UtilCommon';

@Pipe({
    name: 'dateFormatPipe',
})
export class DateFormatPipe implements PipeTransform {
    constructor(private _appState: AppState){

    }
    transform(value: string) {
        // const datePipe = new DatePipe(this._appState.getLocaleFromProfileSetting());
        // value = datePipe.transform(value, this._appState.getDateFromProfileSetting());
        // return value;
        return UtilCommon.formatDate(value, this._appState.getDateFromProfileSetting());
    }
}